module.exports = __webpack_public_path__ + "static/media/developing-cause-content.87607bbe.png";